import ApiKeyTokenRow from './ApiKeyTokenRow';

const ApiKeyTokensTable = ({ tokens, onDelete, onShare, deletingId, sharingId, handleCopy }) => {
  const safeTokens = Array.isArray(tokens) ? tokens : [];

  return (
    <div className='overflow-x-auto border border-gray-200 rounded-md'>
      <table className='min-w-full text-sm'>
        <thead className='bg-gray-50'>
          <tr>
            <th className='text-left p-3 font-semibold'>Key</th>
            <th className='text-left p-3 font-semibold'>Created by</th>
            <th className='text-left p-3 font-semibold'>Created at</th>
            <th className='text-left p-3 font-semibold w-28'>Actions</th>
          </tr>
        </thead>
        <tbody>
          {safeTokens.length === 0 && (
            <tr>
              <td colSpan={4} className='p-4 text-gray-500'>
                No tokens for this user yet.
              </td>
            </tr>
          )}
          {safeTokens.map(row => (
            <ApiKeyTokenRow
              key={row.id}
              row={row}
              onDelete={onDelete}
              onShare={onShare}
              deletingId={deletingId}
              sharingId={sharingId}
              onCopy={handleCopy}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ApiKeyTokensTable;
